import { render } from "./RegisterSolidary.view.vue?vue&type=template&id=ce36e1c2"
import script from "./RegisterSolidary.view.vue?vue&type=script&lang=js"
export * from "./RegisterSolidary.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__